import { useCallback, useEffect, useState } from "react";
import "./recall-details.css";
import axios from "axios";
import {
  AUTO,
  BASE_URL,
  CATEGORY_ID_MAP,
  CHILD,
  CP,
  FOOD,
  MEDICINE,
  PRESS,
  PET
} from "../assets/constant";
import { useSelector } from "react-redux";
import { AutoComponent } from "../components/recall-details/auto";
import { FoodComponent } from "../components/recall-details/foodAndMedicine";
import { PressComponent } from "../components/recall-details/press";
import { ChildComponent } from "../components/recall-details/childAndCP";
import { PetRecallDetails } from "../components/recall-details/pet";
import { ReportIssueModal } from "../components/recall-details/report-issue-modal";
import { CustomModal } from "../components/custom-modal";
import { useNavigate } from "react-router-dom";
import { ShareOptions } from "../components/share-options";

export const RecallDetails = () => {
  const [item, setItem] = useState({});
  const [companyType, setCompanyType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [reportedIssuseConfirmModal, setReportedIssuseConfirmModal] =
    useState(false);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [shareOption, setShareOption] = useState(false);
  const [recallId, setRecallId] = useState(null);

  const user = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const fetchDetails = useCallback(async () => {
    try {
      const href = window.location.href;
      const [type, id] = href.split("/").slice(-2);
      setCompanyType(type);
      setRecallId(id);

      if (type === PET) {
        const response = await axios.get(
          `${BASE_URL}/pet-recall/${id}`,
          {
            headers: {
              Authorization: `Bearer ${user?.token}`
            }
          }
        );
        setItem(response?.data?.data || {});
      } else {
        const response = await axios.post(
          `${BASE_URL}/recall/details`,
          {
            type: CATEGORY_ID_MAP[type],
            recallId: id
          },
          {
            headers: {
              Authorization: `Bearer ${user?.token}`
            }
          }
        );
        setItem(response?.data?.data?.[0] || {});
      }
    } catch (error) {
      console.error(error);
    }
  }, [user?.token]);

  const handleRedirect = () => {
    navigate(-1);
  };

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const recallId = window.location.href.split("/").slice(-1);

    formData.append("recall_Id", recallId);
    formData.append("cat_id", CATEGORY_ID_MAP[companyType]);
    formData.append("user_id", user?.user?.id);
    formData.append("subject", item?.subject || item?.recall_title);
    formData.append('email', user?.user?.email);

    try {
      await axios.post(`${BASE_URL}/issue/create`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "multipart/form-data"
        }
      });
      setShowModal(false);
      setReportedIssuseConfirmModal(true);
    } catch (error) {
      console.error(error);
      setAlertMessage(
        error.response?.data?.message ||
        error.response?.data?.msg ||
        "Something went wrong"
      );
      setAlert(true);
    }
  };

  return (
    <div className="subscriber-container">
      <div className="recall-details-container">
        <div className="recall-details-header">
          <span className="recall-details-title">
            <button
              className="fa-solid fa-arrow-left"
              style={{
                display: "flex",
                cursor: "pointer",
                background: "none",
                border: "none",
                fontSize: "14px"
              }}
              onClick={handleRedirect}
              aria-label="Go back"></button>
            <h4>Recall Details</h4>
          </span>
          <span>
            {[AUTO, FOOD, MEDICINE, CHILD, CP, PRESS].includes(companyType) && (
              <button
                style={{
                  borderRadius: "10px",
                  padding: "10px",
                  fontSize: "14px",
                  marginRight: "10px",
                  textTransform: "none"
                }}
                className="recallButton"
                onClick={() => setShowModal(true)}>
                Report an Issue
              </button>
            )}
            <button
              className="fa fa-share-from-square"
              onClick={() => setShareOption(!shareOption)}
              style={{
                cursor: "pointer",
                background: "none",
                border: "none"
              }}></button>
            {shareOption && (
              <span
                style={{
                  display: "flex",
                  flex: "0 0 auto",
                  gap: "10px",
                  background: "white",
                  padding: "10px",
                  borderRadius: "10px",
                  marginTop: "10px"
                }}>
                <ShareOptions />
              </span>
            )}
          </span>
        </div>
        {showModal && (
          <ReportIssueModal
            showModal={showModal}
            onClose={() => setShowModal(false)}
            handleSubmit={handleSubmit}
            email={user?.user?.email}
            alert={alert}
            alertMessage={alertMessage}
            alertClose={() => setAlert(false)}
            // These props come from the Redux state and URL
            userId={user?.user?.id}  // This will be 726 from your example
            recallId={recallId}       // This comes from the URL
            recallType={CATEGORY_ID_MAP[companyType]} // This maps the company type to ID
          />
        )}
        {reportedIssuseConfirmModal && (
          <CustomModal
            isOpen={reportedIssuseConfirmModal}
            heading="Reported Issue"
            text="Your issue has been reported successfully"
            closeModal={() => setReportedIssuseConfirmModal(false)}
            onClick={() => setReportedIssuseConfirmModal(false)}
            btnName="Ok"
          />
        )}
        {companyType === AUTO && <AutoComponent item={item} />}
        {(companyType === FOOD || companyType === MEDICINE) && (
          <FoodComponent item={item} />
        )}
        {companyType === PRESS && <PressComponent item={item} />}
        {(companyType === CHILD || companyType === CP) && (
          <ChildComponent item={item} />
        )}
        {companyType === PET && <PetRecallDetails item={item} />}
      </div>
    </div>
  );
};